import React from 'react'
import { Link } from 'react-router-dom'
import Page_1 from '../../../assets/images/about/arrow-brudcrumb.svg'
import Page_2 from '../../../assets/images/about/arrow-brudcrumb.svg'
import BgBlog from '../../../assets/images/background/blog-details-bg.jpg'

const PageInear = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${BgBlog})`,
                  }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-12">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>New Consulting For All Kind Offer Business Finance</h2>
                                <div className="header-blog-meta">
                                    <Link to="/Blog" className="date">
                                        18 November 2024{" "}
                                    </Link>
                                    <Link to="/Blog" className="tag">
                                        work
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={Page_1} alt="icon" />
                        </li>
                        <li>
                            <Link to="/Blog">blog</Link>
                        </li>
                        <li>
                            <img src={Page_2} alt="icon" />
                        </li>
                        <li>
                            <span>New Consulting For All Kind Offer Business Finance</span>
                        </li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default PageInear
